export function roundToDecimals(num, places) {
    const factor = Math.pow(10, places);
    return Math.round(num * factor) / factor;
}